import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HotelForm from "./components/HotelForm";
import Itinerarios from "./components/Itinerarios";
import InscripcionForm from "./components/InscripcionForm";


function Tabs() {
  const navigate = useNavigate();
  const location = useLocation();
  //const activeTab = location.pathname === "/itinerarios" ? "itinerarios" : "reserva";
  const activeTab = location.pathname.substring(1);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/reserva", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <nav className="flex justify-center space-x-4 mt-6 mb-8">
        <button
          onClick={() => navigate("/reserva")}
          className={`px-4 py-2 rounded-xl font-semibold transition ${
            activeTab === "reserva"
              ? "bg-teal-700 text-white shadow"
              : "bg-white text-teal-700 border border-teal-700"
          }`}
        >
          Reserva de Hotel
        </button>
        <button
          onClick={() => navigate("/itinerarios")}
          className={`px-4 py-2 rounded-xl font-semibold transition ${
            activeTab === "itinerarios"
              ? "bg-teal-700 text-white shadow"
              : "bg-white text-teal-700 border border-teal-700"
          }`}
        >
          Actividades post congreso
        </button>
        <button
          onClick={() => navigate("/inscripcion")}
          className={`px-4 py-2 rounded-xl font-semibold transition ${
            activeTab === "inscripcion"
              ? "bg-teal-700 text-white shadow"
              : "bg-white text-teal-700 border border-teal-700"
          }`}
        >
          Formulario de Inscripción
        </button>
      </nav>

      <main className="px-4 pb-12">
        <Routes>
          <Route path="/reserva" element={<HotelForm />} />
          <Route path="/itinerarios" element={<Itinerarios />} />
          <Route path="/inscripcion" element={<InscripcionForm />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#fefcf9] text-gray-800">
        <header className="bg-teal-700 text-white p-4 text-center text-2xl font-bold shadow-md">
          XXI UIP WORLD CONGRESS Buenos Aires 2025
        </header>
        <Tabs />
      </div>
    </Router>
  );
}
